
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Laryngeal_neoplasm",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Laryngeal_neoplasm.vue